<template>
  <div id="app-login">
    <form class="form-signin" @submit.prevent="checkLogin()">
      <h1 class="h3 mb-3 font-weight-normal">Log in</h1>
      <label for="inputEmail" class="sr-only">E-mailadres</label>
      <input
        v-model="user.email"
        type="email"
        id="inputEmail"
        class="form-control"
        placeholder="E-mailadres"
        required
        autofocus
      />
      <label for="inputPassword" class="sr-only">Wachtwoord</label>
      <input
        v-model="user.wachtwoord"
        type="password"
        id="inputPassword"
        class="form-control"
        placeholder="Wachtwoord"
        required
      />

      <button class="btn btn-lg btn-primary btn-block" type="submit">
        Inloggen
      </button>

      <p class="help">
        <a href="/wachtwoord-vergeten">Wachtwoord vergeten?</a>
      </p>
    </form>
  </div>
</template>

<script>
//import $ from "jquery";
import "bootstrap";

export default {
  name: "app",
  components: {},
  data() {
    return {
      user: {
        email: "",
        wachtwoord: "",
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    checkLogin() {
      this.$store
        .dispatch("login", {
          user: this.user,
        })
        .then(() => {
          if (this.$store.getters.loggedIn) {
            this.$router.push({ path: "/overzicht2" });
          } else {
            location.reload();
          }
        });
    },
  },
};
</script>

<style>
#app-login {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form-signin {
  width: 100%;
}

.form-signin input {
  margin-bottom: 5px;
}

.help {
  margin-top: 15px;
  text-align: center;
}
</style>
